import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../auth/msalConfig';
import { 
  Box, 
  Button, 
  Container, 
  Typography, 
  Paper,
  CircularProgress
} from '@mui/material';
import { Login as LoginIcon } from '@mui/icons-material';

/**
 * Login page component
 */
const LoginPage = () => {
  const { instance, accounts, inProgress } = useMsal();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get the redirect path from location state or default to home
  const from = location.state?.from?.pathname || '/';
  
  // Redirect to the intended page if already authenticated
  useEffect(() => {
    if (accounts.length > 0 && inProgress === 'none') {
      navigate(from, { replace: true });
    }
  }, [accounts, inProgress, navigate, from]);
  
  const handleLogin = () => {
    try {
      // Try popup first for better debugging
      instance.loginRedirect(loginRequest).catch((error) => {
        console.error('Login error:', error);
      });
    } catch (error) {
      console.error('Error during login:', error);
    }
  };
  
  if (inProgress !== 'none' && inProgress !== 'login') {
    return (
      <Box 
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          gap: 2
        }}
      >
        <CircularProgress color="primary" />
        <Typography variant="body1" color="text.secondary">
          Initializing authentication...
        </Typography>
      </Box>
    );
  }
  
  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper 
        elevation={3} 
        sx={{
          p: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          borderRadius: 2
        }}
      >
        <Typography 
          component="h1" 
          variant="h4" 
          color="primary" 
          gutterBottom
          sx={{ fontWeight: 600 }}
        >
          Astrana Knowledge
        </Typography>
        
        <Typography variant="body1" color="text.secondary" paragraph sx={{ mb: 4 }}>
          Please sign in with your organizational account to access the knowledge base.
        </Typography>
        
        <Button
          variant="contained"
          color="primary"
          size="large"
          startIcon={<LoginIcon />}
          onClick={handleLogin}
          sx={{ py: 1.5, px: 4, borderRadius: 2 }}
        >
          Sign in with Microsoft
        </Button>
      </Paper>
    </Container>
  );
};

export default LoginPage;
